import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import type { ToastType } from './toast.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast',
  template: `<div class="toast-container" [ngClass]="'toast-' + data.type">
    <div class="toast-content">
      <span class="toast-message">{{ data.message }}</span>
    </div>
  </div>`,
  styleUrls: ['./toast.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; type: ToastType; action: string },
  ) {}

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
